export const DEFAULT_TOURNAMENT_LEVELS = [
  { sb: 50, bb: 100, ante: 0, duration: 20, isBreak: false },
  { sb: 75, bb: 150, ante: 0, duration: 20, isBreak: false },
  { sb: 150, bb: 300, ante: 0, duration: 20, isBreak: false },
  { sb: 300, bb: 600, ante: 0, duration: 20, isBreak: false },
  { sb: 500, bb: 1000, ante: 0, duration: 20, isBreak: false },
  { sb: 800, bb: 1600, ante: 0, duration: 20, isBreak: false },
  { sb: 0, bb: 0, ante: 0, duration: 20, isBreak: true },
  { sb: 1500, bb: 3000, ante: 0, duration: 20, isBreak: false },
  { sb: 3000, bb: 6000, ante: 0, duration: 20, isBreak: false },
  { sb: 5000, bb: 10000, ante: 0, duration: 20, isBreak: false },
  { sb: 10000, bb: 20000, ante: 0, duration: 20, isBreak: false },
];

export const DEFAULT_CUSTOM_PAYOUTS = [
  { place: 1, percentage: 60 },
  { place: 2, percentage: 40 },
];

export const getDefaultTournamentLevels = () =>
  DEFAULT_TOURNAMENT_LEVELS.map((level) => ({ ...level }));

export const getDefaultCustomPayouts = () =>
  DEFAULT_CUSTOM_PAYOUTS.map((payout) => ({ ...payout }));
